import { type Url } from "@42.nl/react-url";

export const REFERENCE_APP_URL: Url = "/references";
